import React, { useRef, useState } from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import SelectBox from '../../component/SelectBox';
import Button from '../../component/Button';
import CheckboxComponent from '../../component/CheckboxComponent';
import { useNavigate } from 'react-router-dom';
import GetUserPermission from '../../component/GetUserPermission';

const AdminPermission = (props) => {
    const { isOpen = false, closePopUp, detailInfo } = props
    const selectBoxRef = useRef()
    const navigate = useNavigate()
    const editPermission = GetUserPermission({ key: 'edit' });

    const permissionHeader = [
        'Functionality', 'All', 'View', 'Edit', 'Add', 'Delete'
    ]

    const handleEdit = () => {
        navigate(`?type=edit?id=${detailInfo?.id}`)
        closePopUp()
    }

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp} selectBoxRef={selectBoxRef}>
                <div className={`${classes.adminPermissionWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Admin Details</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.permissionInfoContainer}`}>
                        <div className={`mb-4`}>
                            <div className={`${classes.informationTitle}`}>
                                Profile details
                            </div>
                            <div className={`${classes.infoWrapper}`}>
                                <div className={`${classes.inforCategory}`}>
                                    <div className={`${classes.infoLabel}`}>Name</div>
                                    <div className={`${classes.infoValue}`}>{detailInfo?.name}</div>
                                </div>
                                <div className={`${classes.inforCategory}`}>
                                    <div className={`${classes.infoLabel}`}>Email</div>
                                    <div className={`${classes.infoValue}`}>{detailInfo?.email}</div>
                                </div>
                                {/* <div className={`${classes.inforCategory}`}>
                                    <div className={`${classes.infoLabel}`}>Mobile number</div>
                                    <div className={`${classes.infoValue}`}>9364587102</div>
                                </div> */}
                                <div className={`${classes.inforCategory}`}>
                                    <div className={`${classes.infoLabel}`}>Status</div>
                                    <div className={`${classes.infoValue}`}>{detailInfo?.status ? 'Active' : 'Inactive'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`mb-4`}>
                        <div className={`${classes.informationTitle}`}>
                            Role Permissions
                        </div>
                    </div>
                    <div className={`${classes.permissionRoleContainer}`}>
                        <div className='flex items-center'>
                            {permissionHeader?.map((data) =>
                                <div className={`${classes.permissionCategory} ${classes.permissionHeader}`}>{data}</div>
                            )}
                        </div>
                        <div className=''>
                            {detailInfo?.permissions?.map((item) =>
                                (item?.all || item?.view || item?.edit || item?.add || item?.delete) &&
                                <div className={`flex items-center ${classes.borderRole}`}>
                                    <div className={`${classes.permissionCategory}`}>{item?.title}</div>
                                    <div className={`${classes.permissionCategory}`}>
                                        {item?.all ? <CheckboxComponent checked={item?.all} clickable={false} /> : null}
                                    </div>
                                    <div className={`${classes.permissionCategory}`}>
                                        {item?.view ? <CheckboxComponent checked={item?.view} clickable={false} /> : null}
                                    </div>
                                    <div className={`${classes.permissionCategory}`}>
                                        {item?.edit ? <CheckboxComponent checked={item?.edit} clickable={false} /> : null}
                                    </div>
                                    <div className={`${classes.permissionCategory}`}>
                                        {item?.add ? <CheckboxComponent checked={item?.add} clickable={false} /> : null}
                                    </div>
                                    <div className={`${classes.permissionCategory}`}>
                                        {item?.delete ? <CheckboxComponent checked={item?.delete} clickable={false} /> : null}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {detailInfo?.status && editPermission ?
                        <div className='flex justify-end'>
                            <Button text={"Edit"} className={'!w-[80px] mb-4'} smallBtn onClick={() => handleEdit()} />
                        </div> : null
                    }
                </div>
            </ModalDropdown>
        </>
    );
}

export default AdminPermission